// The Inbox button with its unread badge in the app header (desktop and phone).
export default function InboxBell({ count = 0, onOpen }) {
  return (
    <>
      <style>{'.hc-header > .hc-inbox-bell { display: inline-flex !important; flex-shrink: 0; }'}</style>
      <button type="button" className="hc-inbox-bell" onClick={onOpen} aria-label={count ? 'Inbox, ' + count + ' unread' : 'Inbox'} title="Inbox"
        style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 34, height: 34, marginLeft: 4, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text)', fontSize: 17, lineHeight: 1, padding: 0 }}>
        <span aria-hidden="true">✉</span>
        {count > 0 && <span data-comms-badge style={{ position: 'absolute', top: 1, right: -2, minWidth: 16, height: 16, padding: '0 4px', borderRadius: 8, background: '#C0434A', color: '#fff', fontSize: 10, fontWeight: 700, lineHeight: '16px', textAlign: 'center', boxSizing: 'border-box' }}>{count > 99 ? '99+' : count}</span>}
      </button>
    </>
  )
}
